import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { SHOW_TOAST_MESSAGE } from '../../../helpers/EventEmitter'
import NewsAndSocialService from './services/NewsAndSocialService'

export const postBookmark = createAsyncThunk(
  'companyAnalysis/newsAndSocial/POST_BOOKMARK',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await NewsAndSocialService.postBookmark(params.paramDelete)
      if (res.success) {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: <Translate value="common.toastMessage.BOOKMARK_SAVED" />,
        })
        dispatch(getNewsAndSocials({ ...params.paramsGetTable }))
        return res.data
      }

      return rejectWithValue(res.errors)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const deleteBookmark = createAsyncThunk(
  'companyAnalysis/newsAndSocial/DELETE_BOOKMARK',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await NewsAndSocialService.deleteNewsBookmark(
        data.paramDelete,
      )
      if (res.success) {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: <Translate value="common.toastMessage.BOOKMARK_REMOVED" />,
        })
        dispatch(getNewsAndSocials({ ...data.paramsGetTable }))
        return res.data
      }

      return rejectWithValue(res.errors)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getFiltersThunk = createAsyncThunk(
  'companyAnalysis/newsAndSocial/getFiltersThunk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Promise.all([
        NewsAndSocialService.getNewsType(params),
        NewsAndSocialService.getSentiments(params),
      ])

      if (!res.every((item) => item.success)) {
        return rejectWithValue('Error')
      }

      return res.map((item) => {
        return item.data
      })
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getNewsAndSocials = createAsyncThunk(
  'companyAnalysis/newsAndSocial/GET_NEWS_AND_SOCIALS',
  async (params, { rejectWithValue }) => {
    try {
      const res = await NewsAndSocialService.getNewsAndSocials(params)

      return res.success ? res : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
